import request from '@/utils/request';

export function getEducationColumnIndex() {
  return request({
    url: '/EducationColumn/index',
  });
}

export function getActivityList(params, silentRequest) {
  return request({
    url: '/EducationColumn/activityExplore',
    params,
    silentRequest,
  });
}

export function getArticleExplore(params, silentRequest) {
  return request({
    url: '/EducationColumn/articleExplore',
    params,
    silentRequest,
  });
}

export function getColumnistList(params, silentRequest) {
  return request({
    url: '/EducationColumn/columnistExplore',
    params,
    silentRequest,
  });
}

export function getColumnistDetail(id) {
  return request({
    url: '/EducationColumn/columnistDetail',
    params: {
      id,
    },
  });
}
